import React from 'react'
import loadable from '@loadable/component'

export const Image = loadable(() => import('./Image/Image'))
export const Link = loadable(() => import('./Link/Link'))
export const Navigation = loadable(() => import('./Navigation/Navigation'))
export const Alert = loadable(() => import('./Alert/Alert'))
export const NewsCard = loadable(() => import('./NewsCard/NewsCard'))
export const ArrowPaginate = loadable(() => import('./ArrowPaginate'), { fallback: <></> })
